const MOCK_OFFICE_TASKS = [
  {
    id: "task-1",
    companyId: "shivshankar",
    title: "Verify POD scan for MSKU7845123",
    description:
      "Cross-check seal and unloading photos before finance approval.",
    department: "Operations",
    status: "open",
    priority: "high",
    dueDate: "2026-10-05",
    ownerName: "Karan Joshi",
    assigneeRole: "operations",
    assigneeName: "Karan Joshi",
    dependsOnTaskIds: ["task-4"],
    reminderAt: "2026-10-05T09:00:00Z",
    relatedOrderRef: "ORD-2026-1042",
    createdAt: "2026-10-04T07:00:00Z",
  },
  {
    id: "task-2",
    companyId: "shivshankar",
    title: "Assign backup vehicle for Jamnagar load",
    description: "Primary unit conflict on MH-43 \u2014 planner to reassign.",
    department: "Planning",
    status: "in_progress",
    priority: "medium",
    dueDate: "2026-10-04",
    ownerName: "Neha Desai",
    assigneeRole: "planner",
    assigneeName: "Neha Desai",
    dependsOnTaskIds: [],
    reminderAt: "2026-10-04T08:00:00Z",
    relatedOrderRef: "ORD-2026-1042",
    createdAt: "2026-10-04T06:30:00Z",
  },
  {
    id: "task-3",
    companyId: "world-trans",
    title: "Call UltraTech \u2014 overdue bucket",
    description: "Payment follow-up per ageing preview.",
    department: "Collections",
    status: "open",
    priority: "high",
    dueDate: "2026-10-03",
    ownerName: "Meera Shah",
    assigneeRole: "accountant",
    assigneeName: "Meera Shah",
    dependsOnTaskIds: [],
    reminderAt: "2026-10-03T14:00:00Z",
    deadlineBreached: true,
    relatedOrderRef: "ORD-2026-1038",
    createdAt: "2026-10-03T15:00:00Z",
  },
  {
    id: "task-4",
    companyId: "shivshankar",
    title: "Upload loading photos \u2014 ORD-2026-1042",
    description: "Attach loading category files on order documents tab (mock).",
    department: "Operations",
    status: "done",
    priority: "low",
    dueDate: "2026-10-03",
    ownerName: "Karan Joshi",
    assigneeRole: "operations",
    assigneeName: "Karan Joshi",
    dependsOnTaskIds: [],
    createdAt: "2026-10-02T10:00:00Z",
  },
];
const MOCK_OFFICE_APPROVALS = [
  {
    id: "appr-1",
    companyId: "world-trans",
    type: "customer_rate",
    title: "Customer rate \u2014 ORD-2026-1038",
    summary: "UltraTech Awarpur lane \xB7 margin within band (mock).",
    status: "pending",
    requestedBy: "Rahul Kulkarni",
    requestedAt: "2026-10-03T14:00:00Z",
    amount: 185e3,
    orderRef: "ORD-2026-1038",
    approverRoles: ["group_admin", "accountant"],
  },
  {
    id: "appr-2",
    companyId: "shivshankar",
    type: "low_margin_rate",
    title: "Low margin exception \u2014 ORD-2026-1042",
    summary: "Margin below threshold \u2014 commercial sign-off (mock).",
    status: "pending",
    requestedBy: "Asha Mehta",
    requestedAt: "2026-10-04T08:00:00Z",
    amount: 11e4,
    orderRef: "ORD-2026-1042",
    approverRoles: ["group_admin"],
  },
  {
    id: "appr-3",
    companyId: "shivshankar",
    type: "pod_verification",
    title: "POD verification \u2014 MSKU7845123",
    summary: "Operations \u2192 Finance handoff after upload.",
    status: "pending",
    requestedBy: "Karan Joshi",
    requestedAt: "2026-10-04T07:50:00Z",
    containerNumber: "MSKU7845123",
    orderRef: "ORD-2026-1042",
    approverRoles: ["accountant", "group_admin"],
  },
  {
    id: "appr-4",
    companyId: "shivshankar",
    type: "driver_advance",
    title: "Driver advance \u2014 Sanjay Patil",
    summary: "\u20B912,000 cash component \u2014 open confirmation #14 limits.",
    status: "pending",
    requestedBy: "Neha Desai",
    requestedAt: "2026-10-04T09:00:00Z",
    amount: 12e3,
    approverRoles: ["group_admin", "accountant"],
  },
  {
    id: "appr-5",
    companyId: "shivshankar",
    type: "fuel_issue",
    title: "Fuel issue \u2014 GJ-27-IJ-1102",
    summary: "Diesel litres above trip norm (mock).",
    status: "pending",
    requestedBy: "Operations desk",
    requestedAt: "2026-10-04T06:00:00Z",
    amount: 8500,
    approverRoles: ["group_admin", "operations"],
  },
  {
    id: "appr-6",
    companyId: "shivshankar",
    type: "credit_limit_override",
    title: "Credit limit override \u2014 Reliance Jamnagar",
    summary: "Exposure above limit for new booking (mock).",
    status: "pending",
    requestedBy: "Rahul Kulkarni",
    requestedAt: "2026-10-03T11:00:00Z",
    amount: 25e5,
    approverRoles: ["group_admin"],
  },
  {
    id: "appr-7",
    companyId: "shivshankar",
    type: "invoice",
    title: "Invoice release \u2014 MSKU7845123",
    summary: "Billing pending after POD path (mock).",
    status: "pending",
    requestedBy: "Meera Shah",
    requestedAt: "2026-10-04T10:30:00Z",
    amount: 26e4,
    containerNumber: "MSKU7845123",
    approverRoles: ["accountant", "group_admin"],
  },
];
const MOCK_OFFICE_FOLLOW_UPS = [
  {
    id: "ofu-1",
    companyId: "shivshankar",
    party: "Reliance Industries \u2014 Jamnagar",
    orderRef: "ORD-2026-1042",
    outstanding: 388e3,
    dueDate: "2026-11-03",
    status: "open",
    nextAction: "First reminder call",
    collectorName: "Meera Shah",
    escalationLevel: 0,
  },
  {
    id: "ofu-2",
    companyId: "world-trans",
    party: "UltraTech Cement \u2014 Awarpur",
    orderRef: "ORD-2026-1038",
    outstanding: 168e3,
    dueDate: "2026-10-18",
    status: "promised",
    nextAction: "Confirm NEFT on promise date",
    collectorName: "Meera Shah",
    promiseDate: "2026-10-15",
    promiseAmount: 168e3,
    paymentEvidence: {
      fileName: "neft-ut-clarification.pdf",
      uploadedAt: "2026-10-03T16:00:00Z",
      mode: "neft",
      reference: "UTR-MOCK-88341",
    },
    escalationLevel: 0,
  },
  {
    id: "ofu-3",
    companyId: "shivshankar",
    party: "Adani Ports \u2014 Mundra",
    orderRef: "ORD-2026-1029",
    outstanding: 92e3,
    dueDate: "2026-10-02",
    status: "escalated",
    nextAction: "Escalated to commercial head (mock)",
    collectorName: "Rahul Kulkarni",
    escalationLevel: 2,
  },
];
const MOCK_OFFICE_REMINDERS = [
  {
    id: "rem-1",
    companyId: "shivshankar",
    kind: "pod_sla",
    title: "POD SLA \u2014 MSKU7845123",
    body: "POD still pending 48h after unloading (mock rule).",
    dueAt: "2026-10-04T18:00:00Z",
    read: false,
    href: "/app/pod/pod-1",
  },
  {
    id: "rem-2",
    companyId: "shivshankar",
    kind: "payment_due",
    title: "Payment due \u2014 Reliance",
    body: "Account portion due in 5 days.",
    dueAt: "2026-10-08T09:00:00Z",
    read: false,
    href: "/app/office/follow-ups/ofu-1",
  },
  {
    id: "rem-3",
    companyId: "world-trans",
    kind: "task_deadline",
    title: "Task deadline breached",
    body: "Call UltraTech \u2014 overdue bucket (escalation raised).",
    dueAt: "2026-10-04T17:00:00Z",
    read: true,
    href: "/app/office/tasks/task-3",
  },
  {
    id: "rem-4",
    companyId: "shivshankar",
    kind: "vehicle_unassigned",
    title: "Vehicle not assigned",
    body: "Container TCLU5521901 still unplanned (mock).",
    dueAt: "2026-10-04T12:00:00Z",
    read: false,
    href: "/app/planning/containers",
  },
];
const MOCK_OFFICE_ESCALATIONS = [
  {
    id: "esc-1",
    companyId: "shivshankar",
    trigger: "vehicle_not_assigned",
    title: "Vehicle not assigned \u2014 TCLU5521901",
    detail:
      "Planning window elapsed without vehicle allocation (mock SLA copy).",
    severity: "medium",
    raisedAt: "2026-10-04T08:00:00Z",
    status: "open",
    ownerDepartment: "Planning",
  },
  {
    id: "esc-2",
    companyId: "world-trans",
    trigger: "loading_delayed",
    title: "Loading delayed \u2014 ORD-2026-1038",
    detail: "Loading milestone not confirmed within set time (mock).",
    severity: "medium",
    raisedAt: "2026-10-04T06:00:00Z",
    status: "open",
    ownerDepartment: "Operations",
  },
  {
    id: "esc-3",
    companyId: "shivshankar",
    trigger: "pod_sla_breached",
    title: "POD SLA \u2014 MSKU7845123",
    detail: "POD not received within SLA after unloading (mock).",
    severity: "high",
    raisedAt: "2026-10-04T07:00:00Z",
    status: "open",
    ownerDepartment: "Operations",
  },
  {
    id: "esc-4",
    companyId: "shivshankar",
    trigger: "invoice_pending_after_pod",
    title: "Invoice pending after POD approval",
    detail: "POD path complete but invoice still in billing pending (mock).",
    severity: "medium",
    raisedAt: "2026-10-04T10:00:00Z",
    status: "acknowledged",
    ownerDepartment: "Finance",
  },
  {
    id: "esc-5",
    companyId: "shivshankar",
    trigger: "payment_due_or_overdue",
    title: "Payment overdue \u2014 Adani Ports",
    detail: "Outstanding \u20B992,000 past due date (mock ageing).",
    severity: "high",
    raisedAt: "2026-10-03T09:00:00Z",
    status: "open",
    ownerDepartment: "Collections",
  },
  {
    id: "esc-6",
    companyId: "shivshankar",
    trigger: "credit_limit_exceeded",
    title: "Credit limit exceeded \u2014 Reliance",
    detail: "Exposure above approved limit for new movement (mock).",
    severity: "high",
    raisedAt: "2026-10-03T11:30:00Z",
    status: "open",
    ownerDepartment: "Commercial",
  },
  {
    id: "esc-7",
    companyId: "shivshankar",
    trigger: "driver_advance_unsettled",
    title: "Driver advance unsettled \u2014 Sanjay Patil",
    detail: "Advance issued; settlement pending on trip close (mock).",
    severity: "medium",
    raisedAt: "2026-10-04T09:30:00Z",
    status: "open",
    ownerDepartment: "Finance",
  },
  {
    id: "esc-8",
    companyId: "world-trans",
    trigger: "task_deadline_breached",
    title: "Task deadline breached",
    detail: "Collection call task past due \u2014 owner Meera Shah (mock).",
    severity: "medium",
    raisedAt: "2026-10-04T08:00:00Z",
    status: "open",
    ownerDepartment: "Collections",
  },
];
const MOCK_OFFICE_DOCUMENTS = [
  {
    id: "doc-1",
    companyId: "shivshankar",
    entityType: "vehicle",
    entityLabel: "MH-43-EF-2210",
    documentType: "Insurance",
    fileName: "insurance-mh43-2026.pdf",
    expiresOn: "2026-11-15",
    status: "valid",
  },
  {
    id: "doc-2",
    companyId: "shivshankar",
    entityType: "driver",
    entityLabel: "Sanjay Patil",
    documentType: "Driving licence",
    fileName: "dl-sanjay.pdf",
    expiresOn: "2026-10-20",
    status: "expiring_soon",
  },
  {
    id: "doc-3",
    companyId: "world-trans",
    entityType: "party",
    entityLabel: "UltraTech Cement",
    documentType: "GST registration",
    fileName: "gst-ultratech.pdf",
    expiresOn: "2025-12-01",
    status: "expired",
  },
  {
    id: "doc-4",
    companyId: "shivshankar",
    entityType: "order",
    entityLabel: "ORD-2026-1042",
    documentType: "Customer PO",
    fileName: "po-reliance-jamnagar.pdf",
    expiresOn: "2027-01-01",
    status: "valid",
  },
];
const MOCK_COLLECTOR_METRICS = [
  {
    collectorName: "Meera Shah",
    companyId: "shivshankar",
    openFollowUps: 2,
    promisedAmount: 0,
    collectedMtd: 52e4,
    escalations: 1,
  },
  {
    collectorName: "Rahul Kulkarni",
    companyId: "shivshankar",
    openFollowUps: 1,
    promisedAmount: 168e3,
    collectedMtd: 31e4,
    escalations: 0,
  },
  {
    collectorName: "Meera Shah",
    companyId: "world-trans",
    openFollowUps: 1,
    promisedAmount: 168e3,
    collectedMtd: 168e3,
    escalations: 0,
  },
];
export {
  MOCK_COLLECTOR_METRICS,
  MOCK_OFFICE_APPROVALS,
  MOCK_OFFICE_DOCUMENTS,
  MOCK_OFFICE_ESCALATIONS,
  MOCK_OFFICE_FOLLOW_UPS,
  MOCK_OFFICE_REMINDERS,
  MOCK_OFFICE_TASKS,
};
